import React, { useState } from 'react';
import { Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CancelIcon from '@mui/icons-material/Cancel';

export default function TableFilter({ value, setValue, data, filterName }) {
  const [focused, setFocused] = useState(false);

  return (
    <FormControl
      variant='outlined'
      size='small'
      sx={{
        minWidth: { xs: "100%", sm: "150px" },
        marginRight: { xs: 0, sm: "10px" },
        marginBottom: { xs: 1, sm: 0 },
      }}
      focused={focused}
    >
      <InputLabel id="demo-select-label">{filterName}</InputLabel>
      <Select
        labelId="demo-select-label"
        multiple
        value={value}
        label={filterName}
        onChange={(e) => setValue([...e.target.value])}
        IconComponent={KeyboardArrowDownIcon}
        onOpen={() => setFocused(true)}
        onClose={() => setFocused(false)}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span style={{ color: '#999' }}>Select {filterName}</span>;
          } else if (selected.length === 1) {
            const selectedItem = data.find(item => item.value == selected[0]);
            return (
              <Chip
                label={selectedItem?.label || selected[0]}
                clickable
                deleteIcon={
                  <CancelIcon
                    onMouseDown={(event) => {
                      event.stopPropagation();
                      setValue([]);
                      setFocused(false);
                    }}
                  />
                }
                onDelete={() => {
                  setValue([]);
                  setFocused(false);
                }}
              />
            );
          } else {
            const firstItem = data.find(item => item.value == selected[0]);
            const additionalCount = selected.length - 1;
            return (
              <Chip
                label={`${firstItem?.label || selected[0]}, +${additionalCount}`}
                clickable
                deleteIcon={
                  <CancelIcon
                    onMouseDown={(event) => {
                      event.stopPropagation();
                      setValue([]);
                      setFocused(false);
                    }}
                  />
                }
                onDelete={() => {
                  setValue([]);
                  setFocused(false);
                }}
              />
            );
          }
        }}
      >
        {data.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            <Checkbox checked={value.includes(item.value)} />
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
